export default class InjectionRowProxy {
    /**
     * @param {InjectionRow} target
     * @param {{}} col?
     */
    constructor(target, col = {}) {
        this._target = target;
        this._values = col;
        this._displayValues = {}
    }

    get id() {
        return this._target.id
    }

    get injection() {
        return this._target.injection
    }

    get col() {
        return this._values;
    }

    get peaks() {
        return this._target.peaks;
    }

    get unknownPeaks() {
        return this._target.unknownPeaks;
    }

    get substances() {
        return this._target.substances;
    }

    get chromatograms() {
        return this._target.chromatograms
    }

    /** @returns {number} */
    get peaksCount(){
        return this.peaks.length
    }

    /** @returns {number} */
    get unknownPeaksCount(){
        return this.unknownPeaks.length
    }

    /**
     * @param {string} colName
     * @param {*}value
     */
    setDisplayValue(colName, value){
        this._displayValues[colName] = value
    }

    /** @param {string} colName */
    removeDisplayValue(colName){
        delete this._displayValues[colName]
    }

    /**
     * @param {string} colName
     * @returns {*}
     */
    getDisplayValue(colName) {
        if (this._displayValues.hasOwnProperty(colName))
            return this._displayValues[colName];
        return this._values[colName];
    }
}